export enum FeedPostStatus {
    DELETED = 0,
    ACTIVE = 1,
    PENDING = 2,
    DECLINED = 3
}